var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTableComponentVisible)?_c(_vm.component,{ref:"table",tag:"component",class:{ 'no-print': _vm.isQuickPrint }}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }